import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import ForgetPassword from "../pages/auth/ForgetPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import Home from "../pages/home/Home";
import AboutUs from "../pages/aboutus/AboutUs";
import ContactUs from "../pages/contactus/ContactUs";
import HomeHeader from "../components/layout/home/header/HomeHeader";
import HomeFooter from "../components/layout/home/footer/HomeFooter";
import CenterRegister from "../pages/auth/CenterRegister";
import Profile from "../pages/profile/Profile";
import ProtectedRoute from "./ProtectedRoute";
import SearchCenter from "../pages/searchcenter/SearchCenter";
import Donation from "../pages/donation/Donation";
import SpeakerRequest from "../pages/speaker_request/SpeakerRequest";
import Book from "../pages/book/book";
import DonationSucess from "../pages/donation/donationsucess";
import DonationCancel from "../pages/donation/donationcancel";
import Letter from "../pages/donation/letter";
import PrivacyPolicy from "../pages/PrivacyPolicy/privacypolicy";
import TermOfService from "../pages/Termofconditions/termsofservice";
import AcceptableUsePolicy from "../pages/AcceptablePolicy/acceptablepolicy";
import Donate from "../pages/donation/donate";
import Information from "../pages/donation/information";
// import Churchesabout from "../pages/aboutus/churches";
import HBCU from "../pages/hbcu/hbcu";
import Jointheprolifemovement from "../pages/college/collegeintern";
import CenterSucess from "../pages/auth/Centersucess";
import NewDonationPage from "../pages/donation/newdonationpage"
import SpecialDonationPage from "../pages/donation/specialdonationpage";
import ForgottenWomen from "../pages/home/forgottenwomen";
// import Churches from "../pages/churches/Churches";
import Pricing from "../pages/pricing/Pricing";
import NewsLetter from "../pages/newsletter/newsletter";
import LiveStreams from "../pages/live-streams/LiveStreams";
// import StreamDetail from "../pages/live-streams/stream-detail/StreamDetail";
import StreamByFolder from "../pages/live-streams/stream-detail/StreamByFolder";
import StreamGuard from "../components/StreamGuard/StreamGuard";
// import TopNotice from "../components/TopNotice/TopNotice";
import University from "../pages/universities/university";
import SmsConsetForm from "../smsconsent/smsmconsetformcomponent";
import GroupRegister from "../pages/auth/GroupRegistration";
import Pastor from "../pages/pastor/pastor";
// import LoveSmarterBook from "../pages/book/LoveSmarterBook";
import WallOfPromise from "../pages/wallOfPromise/wallOfPromise";
import BookSponsorshipPage from "../pages/bookDonation/BookSponsorshipPage";

const LoginRoutes = () => {
  return (
    <>
      {/* <TopNotice/> */}
      <HomeHeader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        {/* <Route path="/book" element={<Book />} /> */}
        <Route path="/contactus" element={<ContactUs />} />
        {/* <Route path="/churches" element={<Churches/>}/> */}
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/live-streams" element={<LiveStreams />} />
        <Route path="/live-streams/:streamId" element={
          <StreamGuard>
            <StreamByFolder />
          </StreamGuard>
        } />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/campaign-register" element={<CenterRegister />} />
        <Route path="/search-campaign" element={<SearchCenter />} />
        <Route path="/donation/:slug" element={<Donation />} />
        {/* <Route path="/speaker-request" element={<SpeakerRequest />} /> */}
        <Route path="/success" element={<DonationSucess />} />
        <Route path="/cancel" element={<DonationCancel />} />
        {/* <Route path="/letter" element={<Letter/>}/> */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/termofservice" element={<TermOfService />} />
        <Route path="/acceptableuseofservice" element={<AcceptableUsePolicy />} />
        <Route path="/donate-to-us" element={<Donate />} />
        <Route path="/information" element={<Information />} />
        <Route path="/pastor" element={<Pastor />} />
        {/* <Route path="/church" element={<Churchesabout/>}/> */}
        {/* <Route path="/hbcu" element={<HBCU/>}/> */}
        {/* <Route path="/join-the-pro-life-movement" element={<Jointheprolifemovement/>}/> */}
        <Route path="/thank-you" element={<CenterSucess />} />
        {/* <Route path="/love-smarter-not-harder" element={<LoveSmarterBook/>}/> */}
        <Route path="/love-smarter-not-harder" element={<WallOfPromise />} />
        <Route path="/wall-of-promise" element={<WallOfPromise />} />
        <Route path="/checkout" element={<BookSponsorshipPage />} />
        <Route path="/newsletter" element={<NewsLetter />} />
        <Route path="/university" element={<University />} />
        <Route path="/sms-consent-proof" element={<SmsConsetForm />} />
        <Route path="/group-register/:id" element={<GroupRegister />} />
        {/* <Route path="/special-donation" element={<NewDonationPage/>}/> */}
        {/* <Route path="/give-now" element={<SpecialDonationPage/>}/> */}
        {/* <Route path="/forgottenwomen" element={<ForgottenWomen/>}/> */}


        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
      </Routes>
      <HomeFooter />
    </>
  );
};

export default LoginRoutes;
